export const APP_API_SERVER = "https://realtime.bot.media/api";
